import {Repository} from '@s-ui/domain'

/**
 * @interface
 * */
export default class BreadcrumbRepository extends Repository {
  /**
   * @method
   * @return {Error}
   */
  getBreadcrumbs() {
    throw new Error('[BreadcrumbRepository#getBreadcrumbs] must be implemented')
  }
}
